const STORAGE_KEY = 'wingit_aircraft_wb_constants_v1';

export function loadAircraftWbConstantsMap() {
  if (typeof window === 'undefined') return {};

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (err) {
    return {};
  }
}

export function saveAircraftWbConstantsMap(map) {
  if (typeof window === 'undefined') return;

  try {
    const safeMap = map && typeof map === 'object' ? map : {};
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(safeMap));
  } catch (err) {
    // Ignore storage errors.
  }
}

export function getAircraftWbConstants(aircraftId) {
  const map = loadAircraftWbConstantsMap();
  return map[String(aircraftId)] || {};
}

export function setAircraftWbConstants(aircraftId, constants) {
  const map = loadAircraftWbConstantsMap();
  map[String(aircraftId)] = constants || {};
  saveAircraftWbConstantsMap(map);
}
